import React, { useState, useEffect } from "react"
import axios from 'axios'
import { Link } from "react-router-dom"

export const Procurement = () => {
    // Sesuaikan state dengan output object dari Controller terbaru
    const [summary, setSummary] = useState({
        totalNilai: 0,
        totalProyek: 0,
        proyekTersedia: 0,
        proyekSelesai: 0
    })
    const [klaster, setKlaster] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const fetchSummary = async () => {
            try {
                const res = await axios.get("/api/csr/portal/summary")
                if (res.data.summary) setSummary(res.data.summary)
                setKlaster(res.data.perKlaster || [])
                setLoading(false)
            } catch (err) {
                console.error("Gagal load summary", err)
                setLoading(false)
            }
        }
        fetchSummary()
    }, [])

    if (!loading && summary.totalProyek === 0) return null

    return (
        <header className="ms-hero-page-override ms-hero-img-bekasi ms-bg-fixed no-mt pb-4">
            <div className="container">
                <div className="row no-shadow">
                    <div className="col-lg-12 text-center">
                        <h1 className="color-white font-bold mb-4">
                            Peluang Kemitraan dan Promosi Digital di Kota Bekasi
                        </h1>

                        <div className="row justify-content-center">
                            {/* ================= KOLOM KIRI: PELUANG KEMITRAAN ================= */}
                            <div className="col-lg-5 col-md-6 col-sm-12 mb-2">
                                <div className="card card-banner animated zoomInUp animation-delay-3" style={{ minHeight: '400px', display: 'flex', flexDirection: 'column', justifyContent: 'between' }}>
                                    {/* Bagian Icon Bullet */}
                                    <div className="card-header bg-success shadow-2dp" style={{ width: '60px', height: '60px', borderRadius: '50%', margin: '-30px auto 0', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2 }}>
                                        <i className="fa fa-handshake-o" style={{ fontSize: '28px', color: '#fff' }}></i>
                                    </div>

                                    <div className="card-body mt-3 text-center d-flex flex-column justify-content-between">
                                        <div>
                                            <h1 className='color-black font-bold lh-125 no-m'>PELUANG KEMITRAAN STRATEGIS</h1>
                                            <h3 className='color-dark font-bold lh-125 no-m'>Peluang Kemitraan & Pasokan Komoditas</h3>
                                            <h3 className='text-dark lh-125 no-m' style={{ textAlign: 'justify', textJustify: 'inter-word' }}>
                                                Jembatan inklusif yang menghubungkan kebutuhan rantai pasok industri dengan potensi lokal. Temukan peluang proyek dan draf kebutuhan pengadaan terbaru yang siap dikerjakan oleh pelaku usaha Kota Bekasi.
                                            </h3>
                                        </div>

                                        <div className="lh-125 mt-3">
                                            <Link to={'/kebutuhan-pengadaan'} className="btn btn-raised btn-primary br-2 px-4">Jelajahi Peluang</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* ================= KOLOM KANAN: PROMOSI PRODUK UMKM ================= */}
                            <div className="col-lg-5 col-md-6 col-sm-12 mb-2">
                                <div className="card card-banner animated zoomInUp animation-delay-3" style={{ minHeight: '400px', display: 'flex', flexDirection: 'column', justifyContent: 'between' }}>
                                    {/* Bagian Icon Bullet */}
                                    <div className="card-header bg-success shadow-2dp" style={{ width: '60px', height: '60px', borderRadius: '50%', margin: '-30px auto 0', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2 }}>
                                        <i className="fa fa-bullhorn" style={{ fontSize: '28px', color: '#fff' }}></i>
                                    </div>

                                    <div className="card-body mt-3 text-center d-flex flex-column justify-content-between">
                                        <div>
                                            <h1 className='color-black font-bold lh-125 no-m'>PROMOSI PRODUK UMKM</h1>
                                            <h3 className='color-dark font-bold lh-125 no-m'>Etalase Promosi UMKM Digital Unggulan</h3>
                                            <h3 className='text-dark lh-125 no-m' style={{ textAlign: 'justify', textJustify: 'inter-word' }}>
                                                Etalase digital produk lokal unggulan Kota Bekasi yang terverifikasi resmi oleh dinas. Ruang unjuk gigi bagi kreativitas pelaku usaha untuk menjangkau pasar yang lebih luas, meningkatkan daya saing komoditas, dan menarik investasi strategis.
                                            </h3>
                                        </div>

                                        <div className="lh-125 mt-3">
                                            <Link to={'/promosi'} className="btn btn-raised btn-primary br-2 px-4">Lihat Produk</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </header>
    )
}